import React from "react";
import { Link } from "react-router-dom";
import { Newspaper, Users, TrendingUp, Shield } from "lucide-react";

export default function About() {
  return (
    <div className="pt-32 pb-20">
      <div className="max-w-3xl mx-auto px-6">
        <span className="font-mono text-xs text-yellow-400 uppercase tracking-[0.3em]">/about</span>
        <h1 className="font-display font-bold text-5xl md:text-6xl text-[var(--text-primary)] tracking-tighter mt-2">
          About MediaCrypto
        </h1>
        <p className="text-[var(--text-secondary)] mt-6 text-lg leading-relaxed">
          MediaCrypto is a real-time cryptocurrency news and community platform built for traders, developers, and analysts who demand signal over noise.
        </p>
      </div>

      <div className="max-w-3xl mx-auto px-6 mt-16 space-y-10 text-[var(--text-secondary)] leading-relaxed">

        <section>
          <h2 className="font-display font-bold text-3xl text-[var(--text-primary)] mb-4">Our Mission</h2>
          <p>The crypto space moves fast. Misinformation spreads faster. MediaCrypto was built to cut through the noise and deliver accurate, timely, and insightful coverage of the digital asset markets — from Bitcoin and Ethereum to DeFi, NFTs, and emerging narratives.</p>
          <p className="mt-4">We believe that access to quality financial information shouldn't be gated. Whether you're a seasoned trader or just getting started, MediaCrypto gives you the context you need to make informed decisions.</p>
        </section>

        <section>
          <h2 className="font-display font-bold text-3xl text-[var(--text-primary)] mb-6">What We Cover</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {[
              { icon: TrendingUp, title: "Market Analysis", desc: "In-depth technical and macro analysis, price action breakdowns, and on-chain data insights." },
              { icon: Newspaper, title: "Breaking News", desc: "Real-time coverage of regulatory developments, protocol upgrades, and market-moving events." },
              { icon: Users, title: "Community", desc: "A high-signal forum where traders, builders, and researchers share alpha and debate ideas." },
              { icon: Shield, title: "DeFi & Web3", desc: "Coverage of decentralized finance protocols, NFT markets, and the broader Web3 ecosystem." },
            ].map((item) => {
              const Icon = item.icon;
              return (
                <div key={item.title} className="bg-[var(--bg-panel)] border border-[var(--border-soft)] p-6 hover:border-yellow-400/30 transition">
                  <Icon className="w-5 h-5 text-yellow-400 mb-3" />
                  <h3 className="font-display font-bold text-[var(--text-primary)] text-lg mb-2">{item.title}</h3>
                  <p className="text-sm text-[var(--text-secondary)]">{item.desc}</p>
                </div>
              );
            })}
          </div>
        </section>

        <section>
          <h2 className="font-display font-bold text-3xl text-[var(--text-primary)] mb-4">Editorial Standards</h2>
          <p>Every article published on MediaCrypto is researched and written with accuracy as the top priority. We clearly distinguish between news reporting and opinion. We do not accept payment for editorial coverage, and our editorial team operates independently.</p>
          <p className="mt-4">We are committed to correcting errors promptly and transparently. If you spot an error, please contact us.</p>
        </section>

        <section>
          <h2 className="font-display font-bold text-3xl text-[var(--text-primary)] mb-4">Disclaimer</h2>
          <div className="bg-[var(--bg-panel)] border border-yellow-400/20 p-6">
            <p className="text-sm text-[var(--text-secondary)]">
              <strong className="text-yellow-400">Not Financial Advice.</strong> The content on MediaCrypto is for informational purposes only and does not constitute financial, investment, legal, or tax advice. Cryptocurrency investments carry significant risk. Always do your own research and consult a qualified financial advisor before making investment decisions.
            </p>
          </div>
        </section>

        <section>
          <h2 className="font-display font-bold text-3xl text-[var(--text-primary)] mb-4">Contact</h2>
          <p>Have a tip, correction, or want to get in touch?</p>
          <div className="mt-4 bg-[var(--bg-panel)] border border-[var(--border-soft)] p-4 font-mono text-sm">
            <p className="text-yellow-400">MediaCrypto</p>
            <p className="text-[var(--text-secondary)] mt-1">mediacrypto.ai</p>
            <p className="text-[var(--text-secondary)]">contact@mediacrypto.ai</p>
          </div>
        </section>

        <div className="pt-6 flex gap-4">
          <Link to="/news" className="bg-yellow-400 text-black font-bold uppercase tracking-wide px-6 py-3 hover:bg-yellow-500 transition text-sm">
            Read Latest News
          </Link>
          <Link to="/community" className="border border-[var(--border-soft)] text-[var(--text-primary)] font-mono uppercase tracking-wide px-6 py-3 hover:border-yellow-400 hover:text-yellow-400 transition text-sm">
            Join Community
          </Link>
        </div>

      </div>
    </div>
  );
}